import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IKeyArray } from 'types/IKeyArray';
import { IEntityReducer } from 'core/reducers/entities';
import { IStateReducer } from 'core/reducers/state';
import { assetId, AssetType, IAsset } from 'types/app/asset';
import { ISessionReducer } from 'core/slices/session';
import { ICourseProgress } from 'types/domain/permissions';
import { IModule } from 'types/domain/module';
import { IPreview } from 'core/slices/register';
import { IPreviewState } from 'core/slices/preview';

const entities = (state: RootState) => state.entity.present;
const state = (state: RootState) => state.state;
const assets = (state: RootState) => state.core.assets;
const session = (state: RootState) => state.session;
const preview = (state: RootState) => state.preview;

export const selectPreview = createSelector(
  [entities, state, session, assets],
  (entities: IEntityReducer, state: IStateReducer, session: ISessionReducer, assets: IKeyArray<IAsset>) => {
    if (state[EntityTypes.COURSE_PROGRESS]) {
      const accessPermission: ICourseProgress =
        entities[EntityTypes.COURSE_PROGRESS][state[EntityTypes.COURSE_PROGRESS]];

      if (accessPermission.moduleId) {
        const module: IModule = entities[EntityTypes.MODULE][accessPermission.moduleId];
        return {
          name: module.name,
          image: assets[assetId(EntityTypes.MODULE, module.id, AssetType.PREVIEW, module.imageId)],
          text: entities[EntityTypes.TEXT][module.textId],
          notification: entities[EntityTypes.NOTIFICATION][accessPermission.notificationId],
          type: EntityTypes.COURSE_PROGRESS,
          id: accessPermission.id,
        };
      }
      // } else if (state[EntityTypes.ORG_USER_CERTIFICATE]) {
      //   const orgUserCert: IOrgUserCertificate = session.certificateTokens[state[EntityTypes.ORG_USER_CERTIFICATE]];
      //   const certificate: ICertificate = entities[EntityTypes.CERTIFICATE][orgUserCert.certificateId];

      //   return {
      //     name: certificate.name,
      //     image: assets[assetId(EntityTypes.CERTIFICATE, certificate.id, AssetType.PREVIEW, certificate.imageId)],
      //     text: entities[EntityTypes.TEXT][certificate.textId],
      //     notification: Object.values(entities[EntityTypes.NOTIFICATION])
      //       .reverse()
      //       .find((not: INotification) => not.userCertificateId === orgUserCert.id),
      //     type: EntityTypes.ORG_USER_CERTIFICATE,
      //     id: orgUserCert.id,
      //   };
      // }
    }
  },
);

export const selectPreviewType = createSelector(preview, (preview: IPreviewState) => preview.type);
